<template>
    <div class="external-activity--footer" v-if="activity.social && Object.keys(activity.social) && Object.keys(activity.social).length > 0">
        <span v-for="(link, type) in activity.social" style="margin-right: 10px; font-size: 20px;">
            <template v-if="type === 'email' && link">
                <a :href="`mailto:${link}`" style="text-decoration: none; color: black"><i class="fa fa-envelope"></i></a>
            </template>
            <template v-if="type === 'whatsapp' && link">
                <a :href="'https://wa.me/' + link" target="_blank" style="text-decoration: none; color: black"><i :class="`fab fa-${type}`"></i></a>
            </template>
            <template v-if="link != '' && link != null && type !== 'email' && type !== 'whatsapp'">
                <a :href="link" target="_blank" style="text-decoration: none; color: black"><i :class="`fab fa-${type}`"></i></a>
            </template>
        </span>
    </div>
</template>
<script>
    export default {
        props: ['activity']
    }
</script>
